import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';

import { CustomsEntryDetail } from '../../../models';
import { TmsWebBaseEditCreateService } from '../../base';

@Injectable({
  providedIn: 'root',
})
export class CustomsEntryDetailService extends TmsWebBaseEditCreateService<CustomsEntryDetail, CustomsEntryDetail> {
  public refreshDetails = new Subject<void>();

  constructor() {
    super('CustomsEntryDetail', $localize`Customs Entry`);
  }

  getForPurchaseInvoice(purchaseInvoiceHeaderId: string): Observable<CustomsEntryDetail[]> {
    return this.httpService.get<CustomsEntryDetail[]>(
      `${this.apiUrl}/GetCustomsEntryDetailsForPurchaseInvoice?id=${purchaseInvoiceHeaderId}`,
    );
  }

  updateCustomsEntryDetails(
    id: string,
    currencyId: string,
    cargoDescription: string,
    importControls: string,
    value: number,
    supplementaryUnits: number,
    numberOfItems: number,
    grossWeight: number,
    nettWeight: number,
    tariffCode: string,
  ): Observable<any> {
    return this.httpService.post(`${this.apiUrl}/UpdateCustomsEntryDetails`, {
      id,
      currencyId,
      cargoDescription,
      importControls,
      value,
      supplementaryUnits,
      numberOfItems,
      grossWeight,
      nettWeight,
      tariffCode,
    });
  }
}
